module.exports = __webpack_public_path__ + "img/sec_step.6aae0a22.png";